import { getCode } from "@/utils/wx.js";
import { request, METHOD } from "../utils/request.js";
import store from '@/store'
import { clearToken } from "@/utils/auth";
import { setSession,setSessionJSON,getLocal } from "@/utils/cookie";
import { router } from "@/router";

export function getTokenApi() {

  const openId = getLocal('openId')
  // 如果没有code 不走接口 否则报错
  if (!openId) return Promise.resolve({ data: { token: '' } })
  return request(
    '/h5Mfitness/login/mobileBind',
    METHOD.POST,
    {
      openId:openId,
      personType: "8"
      
    }
  )


}

export function cppuLogin() {
  return request("/web/login/cppuLogin/login", METHOD.POST, { type: 2 });
}
export function getSchoolList (obj) {
  return request(
      '/h5Mfitness/com/getSchoolList',
      METHOD.GET,
      obj
    )
}
export function getTeacherSchoolList (obj) {
  return request(
      '/h5Mfitness/teacher/getSchoolList',
      METHOD.GET,
      obj
    )
}



// denglv
export function Login (obj) {
  return request(
      '/iot/h5fitness/login/getLogin',
      METHOD.POST,
      obj
    )
}

export function getSnCodeAndStudentName(obj) {
  return request(
    "/iot/h5fitness/login/getSnCodeAndStudentName",
    METHOD.POST,
    obj
  );
}

// export function getJsapiTicket() {
//   return request(
//     `/iot/h5fitness/wxByH5/jsapi/${window.context.VITE_APPID}/getJsapiTicket`,
//     METHOD.GET
//   );
// }
export function getJsapiTicket(data) {
  return request(
    `h5Mfitness/wx/getJsApi`,
    METHOD.POST,
    data
  );
}


/**
 * 获取微信学生信息
 */
export function getWxStudentInfo() {
  return request("/iot/h5fitness/login/GetWxStudentInfo", METHOD.POST);
}
export function getClassInfoByCampusCode(obj) {
  return request(
    "/iot/h5fitness/login/getClassInfoByCampusCode",
    METHOD.POST,
    obj
  );
}
export function getProcessStudentInfo(obj) {
  return request(
    "/iot/h5fitness/login/getProcessStudentInfo",
    METHOD.POST,
    obj
  );
}
export function getDepartmentToo(obj) {
  return request(
    "/iot/h5fitness/login/getDepartmentToo",
    METHOD.POST,
    obj
  );
}
export function getOneSchool (obj) {
  return request(
    '/iot/h5fitness/login/getOneSchool',
    METHOD.POST,
    obj
  )
}
// 获取个人信息
export function getPersonInfoList (obj) {
  return request(
    '/h5Mfitness/com/getPersonInfoList',
    METHOD.POST,
    obj
  )
}
// 获取学生信息
export function getChildInfoBySnCode (obj) {
  return request(
    '/h5Mfitness/parent/getChildInfoBySnCode',
    METHOD.POST,
    obj
  )
}
// 获取学生信息教师
export function getStudentInfoBySnCode (obj) {
  return request(
    '/h5Mfitness/teacher/getStudentInfoBySnCode',
    METHOD.POST,
    obj
  )
}
// // 获取城市
// export function getCityInfoByCode (obj) {
//   return request(
//     'h5Mfitness/com/getCityInfoByCode',
//     METHOD.POST,
//     obj
//   )
// }
// 根据城市获取学校
export function getSchoolInfoByCityCode (obj) {
  return request(
    'h5Mfitness/com/getSchoolInfoByCityCode',
    METHOD.POST,
    obj
  )
}
